// LOGIN PAGE & AUTH
export class URLList {
  static VERSION = {
    GET_VERSION: `${import.meta.env.VITE_API_BASE_URL}/web/version`,
  };

  static AUTH = {
    GET_SECRET_KEY_BY_COOKIE: `${import.meta.env.VITE_API_BASE_URL}/auth/keys`,
    GET_SECRET_KEY_BY_TOKEN: `${import.meta.env.VITE_API_BASE_URL}/auth/secret-key`,
    USER_TOKEN_CHECK: `${import.meta.env.VITE_API_BASE_URL}/auth/user/token`,
    CHECK_USER_NAME_BY_SMS_TOKEN: `${import.meta.env.VITE_API_BASE_URL}/auth/app/identity`,
    SET_ID_AND_PASSWORD_BY_SMS: `${import.meta.env.VITE_API_BASE_URL}/auth/assign/credentials`,
    CHECK_USER_ID_AVAILABLE: `${import.meta.env.VITE_API_BASE_URL}/auth/check/login-id`,
    TIME_ZONE_CHECK: `${import.meta.env.VITE_API_BASE_URL}/time-zone/check`,
  };

  static PREREGISTRATION = {
    /**
     * 환자가 직접 휴대폰 인증을 통해 로그인 하는 부분으로 /s/를 붙이지 않는다.
     */
    CREATE: `${import.meta.env.VITE_API_BASE_URL}/pre-registration`,
    GET: `${import.meta.env.VITE_API_BASE_URL}/s/pre-registration`,
    UPDATE: `${import.meta.env.VITE_API_BASE_URL}/pre-registration`,
    DELETE: `${import.meta.env.VITE_API_BASE_URL}/s/pre-registration`,
    SSE: `${import.meta.env.VITE_API_BASE_URL}/pre-registration/sse`,
  };

  static AUTH_CODE = {
    URL: `${import.meta.env.VITE_API_BASE_URL}/auth/code`,
    SEND_EMAIL_WITH_LINK: `${import.meta.env.VITE_API_BASE_URL}/auth/sn/find`,
    INIT_PASSWORD: `${import.meta.env.VITE_API_BASE_URL}/auth/sn/init`,
  };

  static HOSPITAL = {
    GET_HOSPITAL_INFO: `${import.meta.env.VITE_API_BASE_URL}/hospital`,
    POST_ADD_HOSPITAL: `${import.meta.env.VITE_API_BASE_URL}/s/hospital`,
    GET_HOSPITAL_LIST: `${import.meta.env.VITE_API_BASE_URL}/s/hospital`,
    DELETE_HOSPITAL: `${import.meta.env.VITE_API_BASE_URL}/s/hospital`,
  };

  static USER = {
    LOGIN: `${import.meta.env.VITE_API_BASE_URL}/auth/web/login`,
    LOGOUT: `${import.meta.env.VITE_API_BASE_URL}/auth/user/logout`,
    RESET_TOKEN: `${import.meta.env.VITE_API_BASE_URL}/auth/user/web/token`,
    GET_USER_INFO: `${import.meta.env.VITE_API_BASE_URL}/s/user/web/info`,
    GET_PATIENT_LIST: `${import.meta.env.VITE_API_BASE_URL}/s/patient/web/list`,
    CREATE_PATIENT_WITH_GUARDIAN: `${import.meta.env.VITE_API_BASE_URL}/s/user/guardian-patient`,
    CHANGE_PASSWORD: `${import.meta.env.VITE_API_BASE_URL}/s/auth/sn`,
    RESEND_SMS_FOR_SETUP_ACCOUNT: `${import.meta.env.VITE_API_BASE_URL}/auth/account/setup/resend`,
  };

  static PATIENT = {
    LIST: `${import.meta.env.VITE_API_BASE_URL}/s/patient/web/list`,
    DETAIL: `${import.meta.env.VITE_API_BASE_URL}/s/patient/info`,
    DEACTIVATE: `${import.meta.env.VITE_API_BASE_URL}/s/patient/deactivate`,
    ACTIVATE: `${import.meta.env.VITE_API_BASE_URL}/s/patient/activate`,
  };

  static DOCTOR = {
    LIST: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor`,
    CREATE: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor`,
    UPDATE: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor`,
    GET: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor/`,
    ACTIVATE: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor/activate`,
    DEACTIVATE: `${import.meta.env.VITE_API_BASE_URL}/s/admin/doctor/deactivate`,
    SEND_PASSWORD_CHANGE_EMAIL: `${
      import.meta.env.VITE_API_BASE_URL
    }/s/admin/doctor/sn/init/resend`,
  };

  static SUPER_ADMIN = {
    OPERATION_LOG: `${import.meta.env.VITE_API_BASE_URL}/s/operation-log`,
    ACTION_LOG: `${import.meta.env.VITE_API_BASE_URL}/s/action-log/list`,
  };

  static TREATMENT = {
    /**
     * 치료 활성화 추가
     * [POST] 를통해서 상
     */
    ADD_TREATMENT: `${import.meta.env.VITE_API_BASE_URL}/s/treatment`,
    /**
     * 치료 활성화 추가 v2 — 스토어 이용권 소진형. 결제·자격 발급(claim)이 끝난 뒤 구매 흐름에서만 호출한다.
     * 서버가 미사용 treatment_voucher 를 요구하고 같은 트랜잭션에서 소진한다. 기존 ADD_TREATMENT 는 이용권과 무관.
     */
    ADD_TREATMENT_V2: `${import.meta.env.VITE_API_BASE_URL}/s/treatment/v2`,
    /**
     * 치료 메모 추가
     * put, treatmentInfoUuid
     */
    ADD_TREATMENT_MEMO: `${import.meta.env.VITE_API_BASE_URL}/s/treatment/memo`,
    /**
     * 치료 중단
     * put, treatmentInfoUuid
     */
    PAUSE_TREATMENT: `${import.meta.env.VITE_API_BASE_URL}/s/treatment/termination`,
    /**
     * 환자 치료 목록 조회
     * [GET] 를통해서 상
     */
    GET_TREATMENT_LIST: `${import.meta.env.VITE_API_BASE_URL}/s/treatment`,
    /**
     * 치료 상세 조회
     */
    GET_TREATMENT_DETAIL: `${import.meta.env.VITE_API_BASE_URL}/s/treatment`,

    /**
     * 치료 활동 차트 데이터 조회
     */
    FETCH_ACTIVITY_CHART_DATE: `${import.meta.env.VITE_API_BASE_URL}/s/treatment/`,
    FETCH_ACTIVITY_CHART_DATE_BY_GZIP: `${import.meta.env.VITE_API_BASE_URL}/s/gzip/treatment/`,
    /**
     * 치료 중단
     */
    TERMINATE_TREATMENT: `${import.meta.env.VITE_API_BASE_URL}/s/treatment/termination`,
  };

  static NOTICE = {
    GET_NOTICE_LIST: `${import.meta.env.VITE_API_BASE_URL}/s/notice-board/post`,
    ADD_NOTICE: `${import.meta.env.VITE_API_BASE_URL}/s/notice-board/post`,
    GET_NOTICE_DETAIL: `${import.meta.env.VITE_API_BASE_URL}/s/notice-board/post`,
    UPADTE_NOTICE: `${import.meta.env.VITE_API_BASE_URL}/s/notice-board/post`,
  };

  static MAINTENANCE = {
    PATIENT: `${import.meta.env.VITE_API_BASE_URL}/s/maintenance/patient`,
    SN_EXPIRE: `${import.meta.env.VITE_API_BASE_URL}/s/maintenance/sn-expire`,
  };
}

export const USER_MANUAL_URL = {
  // SAT-001 사용자 메뉴얼.pdf
  // SAT-001 User Manual.pdf
  userManual: (locale: string) => {
    const fileName =
      locale === "ko"
        ? "SAT-001%20%E1%84%89%E1%85%A1%E1%84%8B%E1%85%AD%E1%86%BC%E1%84%8C%E1%85%A1%20%E1%84%86%E1%85%A6%E1%84%82%E1%85%B2%E1%84%8B%E1%85%A5%E1%86%AF.pdf"
        : "SAT-001%20User%20Manual.pdf";
    return `https://salphapublic.blob.core.windows.net/001-hcp-web/user-manual/${locale}/${fileName}`;
  },
};

export const POLICY_CONSENT_URL = {
  Privacy: (locale: string) =>
    `https://salphapublic.blob.core.windows.net/001-hcp-web/policy-consent/${locale}/Privacy.md`,
  TermsOfService: (locale: string) =>
    `https://salphapublic.blob.core.windows.net/001-hcp-web/policy-consent/${locale}/TermsOfService.md`,
};

// // DASHBOARD PAGE
// export const GET_ADMIN_DASHBOARD_URL = `${import.meta.env.VITE_API_BASE_URL}/s/patient/admin/dashboard`;
// export const CHANGE_PASSWORD_URL = `${import.meta.env.VITE_API_BASE_URL}/s/user/sn`;
